import type { IArtist } from '~/types/api';

export const fetchArtists = async (url: string): Promise<IArtist[]> => {
  return await fetch(url)
    .then(res => res.json())
    .catch(e => e);
};

export default fetchArtists;
